import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { userService } from '@/services';

export function useUser(uid: string | undefined) {
  const queryClient = useQueryClient();

  const {
    data: user,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ['user', uid],
    queryFn: () => userService.getPublicProfile(uid!),
    enabled: !!uid,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  // Set up real-time subscription for this profile
  useEffect(() => {
    if (!uid) return;

    const unsubscribe = userService.subscribeToProfile(uid, updated => {
      queryClient.setQueryData(['user', uid], updated);
    });

    return () => unsubscribe();
  }, [uid, queryClient]);

  return {
    user: user ?? null,
    isLoading,
    isError,
    error: error ?? null,
    refetch,
  };
}
